import * as yup from 'yup';

import { FIELD } from './constants';

export const automaticRosteringSchema = yup.object({
  [FIELD.ENABLED]: yup.boolean().required(),
  // Not required: the backend never sends the stored key back, only a mask, and an empty field
  // means "leave the stored key alone".
  [FIELD.API_KEY]: yup.string(),
  [FIELD.DEFAULT_FOR_ALL_PLAN_UNITS]: yup.boolean().required()
});
